import React, { useMemo } from 'react';
// import { BsWhatsapp } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { IoLogoWhatsapp } from 'react-icons/io';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useMenuManager } from '../../utils/manager/menu-manager';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function usePaymentOfflineModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { spot } = storage;
  const { getWhatsAppLink } = useMenuManager();
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });

  function didOpen() {
    analyticsPageView('Offline Payment');
  }

  const description = useMemo(() => {
    const addressable = spot?.type?.addressable ?? false;

    if (addressable) {
      return t('payment-offline-modal.html.delivery');
    }

    const prepaid = spot?.prepaid ?? false;

    if (prepaid) {
      return t('payment-offline-modal.html.prepaid');
    }

    return t('payment-offline-modal.html');
  }, [spot]);

  async function show() {
    const addressable = spot?.type?.addressable ?? false;

    if (addressable) {
      // TODO
    }

    const result = await swal.fire({
      icon: 'warning',
      title: t('payment-offline-modal.title'),
      html: description,
      confirmButtonText: (
        <>
          <IoLogoWhatsapp /> WhatsApp
        </>
      ),
      cancelButtonText: 'Fechar',
      showConfirmButton: addressable,
      // showConfirmButton: true,
      showCancelButton: true,
      didOpen,
    });

    if (result.isConfirmed) {
      // eslint-disable-next-line no-undef
      window.location.href = getWhatsAppLink();
    }

    return result;
  }

  return {
    showPaymentOfflineModal: show,
  };
}

export { usePaymentOfflineModal };
